import {Component, OnInit, Inject} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { ErrorStateMatcher } from '@angular/material/core';
import {Annotation} from 'src/app/models/annotatios';
import {SubcategoryHistory} from 'src/app/models/subcategory-history';
import {SubcategoryService} from 'src/app/services/subcategory.service';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-member-subcategory-dialog',
  templateUrl: './member-subcategory-dialog.component.html',
  styleUrls: [ './member-subcategory-dialog.component.scss' ]
})
export class MemberSubcategoryDialogComponent implements OnInit {

  public matcher = new FormErrorStateMatcher();
  public entityForm: FormGroup;
  public subcategories: any[] = []
  public isEdit: boolean

  constructor (
    private fb: FormBuilder,
    public matDialogRef: MatDialogRef<MemberSubcategoryDialogComponent>,
    private _subcategoryService: SubcategoryService,
    @Inject(MAT_DIALOG_DATA) public data: SubcategoryHistory
  ) {

    if (this.data.id == '0') {
      this.isEdit = false
    } else {
      this.isEdit = true
    }

    this.entityForm = this.createForm(this.data)

    this.loadSubCategories()
  }

  ngOnInit () {

  }

  createForm (data) {
    let form: FormGroup = this.fb.group({
      id: new FormControl(data.id),
      date: new FormControl(data.date, [Validators.required]),
      member_id: new FormControl(data.member_id, [Validators.required]),
      member_name: new FormControl(data.member_name, [Validators.required]),
      subcategory_id: new FormControl(data.subcategory_id, [Validators.required]),
      subcategory_name: new FormControl(data.subcategory_name, [Validators.required]),
      subcategory_annuity: new FormControl(data.subcategory_annuity),
      annuity_from: new FormControl(data.annuity_from)
    });
    return form
  }

  loadSubCategories () {

    this._subcategoryService.select()
      .subscribe((result) => {
        result.forEach((item) => {

          if (item.payload.doc.data().annuity || item.payload.doc.data().partner) {

            const subCat: any = {}
            subCat.id = item.payload.doc.id
            subCat.name = item.payload.doc.data().name
            subCat.annuity = item.payload.doc.data().annuity

            this.subcategories.push(subCat)

          }

        })

      })

  }

  selectCategory (subcategory_id) {
    let cat = this.subcategories.find((e) => {
      return e.id == subcategory_id
    })

    if (cat) {
      this.entityForm.controls.subcategory_name.setValue(cat.name)
      this.entityForm.controls.subcategory_annuity.setValue(cat.annuity)
      console.log(JSON.stringify(cat))
    }
  }

}
